export default __webpack_public_path__ + "static/media/scooter.a6c0f79a.svg";